import { Component, OnInit, ViewChild } from '@angular/core';
import { debug } from 'console';
import DataSource from 'devextreme/data/data_source';
import { NotificationService } from 'src/app/common/component/notification/notification.service';
import { O2PortalHycoReportService } from 'src/app/reports/o2-reports/o2-portal-hyco-report/service/o2-portal-hyco-report-service';
import { O2PortalHycoOneyrAnalysisReportComponent } from './o2-portal-hyco-oneyr-analysis-report/o2-portal-hyco-oneyr-analysis-report.component';
import { O2PortalHycoFiveyrAnalysisReportComponent } from './o2-portal-hyco-fiveyr-analysis-report/o2-portal-hyco-fiveyr-analysis-report.component';
import { O2PortalHycoRegionalAnalysisReportComponent } from "./o2-portal-hyco-regional-analysis-report/o2-portal-hyco-regional-analysis-report.component";
import { Constants } from 'src/app/common/constants';
import { O2PortalHycoAwardDetailsReportComponent } from './o2-portal-hyco-award-details-report/o2-portal-hyco-award-details-report.component';
@Component({
  selector: 'app-o2-portal-hyco-report',
  templateUrl: './o2-portal-hyco-report.component.html',
  styleUrls: ['./o2-portal-hyco-report.component.scss']
})
export class O2PortalHycoReportComponent implements OnInit {
  isLoadPanelVisible: boolean = false;
  ddbCaledarYearFilterDataSource: any;
  defaultYearSelectionId: number = 2;
  reportLinkArray: any;
  selectedReportLinkId: number = 1;
  selectedReportYear: number;
  selectedAnnouncementYear: number = (new Date().getFullYear() - 1);
  selectedReportYearId: number;
  yearDropdownLabelText: string;
  currentYearMonthsInfo: string = "";
  pageTitle: string = "";
  noOfyear: number = 1;
  consolidatedSOGAnnouncementYearDataSource: any;
  oneYearAnalysisHyCoReportDataSource: any;
  fiveYearAnalysisHyCoReportDataSource: any;
  regionalAnalysisHyCoReportDataSource: any;
  @ViewChild(O2PortalHycoOneyrAnalysisReportComponent) o2PortalHycoOneyrAnalysisReportComponent: O2PortalHycoOneyrAnalysisReportComponent
  @ViewChild(O2PortalHycoFiveyrAnalysisReportComponent) o2PortalHycoFiveyrAnalysisReportComponent: O2PortalHycoFiveyrAnalysisReportComponent
  @ViewChild(O2PortalHycoRegionalAnalysisReportComponent) o2PortalHycoRegionalAnalysisReportComponent: O2PortalHycoRegionalAnalysisReportComponent
  @ViewChild(O2PortalHycoAwardDetailsReportComponent) o2PortalHycoAwardDetailsReportComponent: O2PortalHycoAwardDetailsReportComponent

  constructor(private notificationService: NotificationService, private o2PortalHycoReportService: O2PortalHycoReportService) {
    this.setReportCalendarYearFilterLabel(1);
    this.getHyCoReportCalendarYears();
  }

  ngOnInit(): void {
  }

  renderReportPage(e) {
    var linkId = e.itemIndex + 1;
    // if NOT same linked clicked then only reder/load report component 
    if (this.selectedReportLinkId != linkId) {
      this.selectedReportLinkId = linkId;
      this.pageTitle = this.o2PortalHycoReportService.getPageTitle(linkId);

      if (e.itemIndex === 0) {
        this.noOfyear = 1;
        this.setReportCalendarYearFilterLabel(linkId);
        this.o2PortalHycoOneyrAnalysisReportComponent.getHyCoAnalysisReportData(this.selectedReportLinkId, this.selectedReportYear);
      } else if (e.itemIndex === 1) {
        this.noOfyear = 5;
        this.setReportCalendarYearFilterLabel(linkId);
        this.o2PortalHycoOneyrAnalysisReportComponent.getHyCoAnalysisReportData(this.selectedReportLinkId, this.selectedReportYear);
      } else if (e.itemIndex === 2) {
        this.o2PortalHycoRegionalAnalysisReportComponent.getFullRegionalAnalysisReportData(this.selectedReportLinkId, this.selectedReportYear);
      }
      else if (e.itemIndex === 3) {
        this.o2PortalHycoAwardDetailsReportComponent.getAwardDetails(this.selectedReportYear, this.noOfyear);
      }
    }
  }

  setReportCalendarYearFilterLabel(linkId: number) {
    this.yearDropdownLabelText = this.o2PortalHycoReportService.setReportCalendarYearFilterLabel(linkId);
    this.pageTitle = this.o2PortalHycoReportService.getPageTitle(linkId);
  }

  getHyCoReportCalendarYears() {
    this.isLoadPanelVisible = true;
    this.o2PortalHycoReportService.getHyCoReportCalendarYears().subscribe({
      next: data => {
        this.ddbCaledarYearFilterDataSource = new DataSource({
          store: {
            data: data,
            type: 'array',
            key: 'id',
          },
        });
        this.isLoadPanelVisible = false;
        this.selectedAnnouncementYear = (new Date().getFullYear() - 1)
      },
      error: (error: any) => {
        this.isLoadPanelVisible = false;
        this.notificationService.alert("error", "Error while fetching Award Announcement Calendar Years", error);
      }
    });
  }

  onYearSelectionChanged(e) {
    this.selectedReportYear = e.selectedItem.announcementYear;
    this.selectedReportYearId = e.selectedItem.id;
  }

  viewReport() {
    this.selectedAnnouncementYear = this.selectedReportYear;
    this.currentYearMonthsInfo = "";
    if (this.selectedReportYear == new Date().getFullYear()) {
      this.currentYearMonthsInfo = '(' + (new Date().getMonth() + 1) + ' Months Data)'
    }

    switch (this.selectedReportLinkId) {
      case 2:
        this.noOfyear = 5;
        this.o2PortalHycoFiveyrAnalysisReportComponent.getHyCoAnalysisReportData(this.selectedReportLinkId, this.selectedReportYear);
        break;
      case 3:
        this.o2PortalHycoRegionalAnalysisReportComponent.getFullRegionalAnalysisReportData(this.selectedReportLinkId, this.selectedReportYear);
        break;
      case 4:
        this.o2PortalHycoAwardDetailsReportComponent.getAwardDetails(this.selectedAnnouncementYear, this.noOfyear);
      default:
        this.noOfyear = 1;
        this.o2PortalHycoOneyrAnalysisReportComponent.getHyCoAnalysisReportData(this.selectedReportLinkId, this.selectedReportYear);
        break;
    }

  }
}
